import React, { useEffect, useState } from "react";
import { Box, Paper, Button } from "@mui/material";
import PaySlipHeader from "./components/payslip.header";
import PayslipEmployeeDetail from "./components/Payslip.employee";
import PayslipEarnings from "./components/Payslip.Earnings";
import { useNavigate, useParams } from "react-router-dom";
import PayslipDeductioin from "./components/payslip.deductioin";
import PayslipNetpay from "./components/Payslip.Netpay";
import PaySlipFooter from "./components/payslip.footer";
import {
  getEmpPaySlipDefault,
  getPayslipByid,
  insertPayslipData,
  updatePayslip,
} from "../../api/payslipApis";
import { showAlert } from "../../actions/alert";
import { handleAxiosError } from "../../config/action-config";
import { useDispatch, useSelector } from "react-redux";
// import converter from "number-to-words";
import DeleteIcon from "@mui/icons-material/Delete";
import { Margin } from "@mui/icons-material";
export default function PayslipEditForm() {
  const navigate = useNavigate();
  const params = useParams();
  const [paySlipData, setPaySlipData] = useState({});
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const[change,setChange]=useState(false);
  const [formData, setFormData] = useState({
    employee_code: "",
    pay_date: "",
    employee: "",
    pay_period: "",
    father_name: "",
    bank_name: "",
    designation: "",
    account_number: "",
    department: "",
    ifsc_code: "",
    pan_number: "",
    payment_mode: "",
    joining_date: "",
    uan_number: "",
    work_location: "",
    effective_days: "",
    tax_deducted_at_source: "",
    epf: "",
    health_insurance: "",
    other_deductions: "",
    total_deductions: "",
    basic_pay: "",
    house_rent_allowance: "",
    special_allowance: "",
    transportaion_allowance: "",
    mobile_tel_allowance: "",
    city_compensatory_allowance: "",
    food_allowance: "",
    other_allowance: "",
    over_time: "",
    bonus: "",
    reimbursement: "",
    other_earnings: "",
    notes: "",
    net_pay_in_words: "",
    net_pay: "",
    header1: "SALARY SLIP",
    header2: "VASTEDGE CLOUD SOLUTIONS PVT LTD",
    header3: "CAPITAL GREENS, 15 SHIVAJI MARG, NEW DELHI 110015",
    footer1:
      "The tax has been deducted tentatively, after considering the maximum limit of tax-saving investment.",
    footer2:
      "The reimbursement amount and Other Earning is not part of the CTC.",
    footer3:
      "This is a system-generated Pay slip and does not require a signature.",
  });
  useEffect(() => {
    fetchDetailByID();
  }, [params.id]);
  async function fetchDetailByID() {
    try {
      const { data } = await getPayslipByid(params.id, user.token);
      setFormData({
        ...formData,
        account_number: data.data[0].account_number,
        bank_name: data.data[0].bank_name,
        employee_code: data.data[0].employee_code,
        pay_date: formatDateToYYYYMMDD(data.data[0].pay_date),
        employee: data.data[0].employee,
        pay_period: data.data[0].pay_period,
        father_name: data.data[0].father_name,
        designation: data.data[0].designation,
        department: data.data[0].department,
        ifsc_code: data.data[0].ifsc_code,
        pan_number: data.data[0].pan_number,
        payment_mode: data.data[0].payment_mode,
        joining_date: formatDateToYYYYMMDD(data.data[0].joining_date),
        uan_number: data.data[0].uan_number,
        work_location: data.data[0].work_location,
        effective_days: data.data[0].effective_days,
        tax_deducted_at_source: data.data[0].tax_deducted_at_source,
        epf: data.data[0].epf,
        health_insurance: data.data[0].health_insurance,
        other_deductions: data.data[0].other_deductions,
        total_deductions: data.data[0].total_deductions,
        basic_pay: data.data[0].basic_pay,
        house_rent_allowance: data.data[0].house_rent_allowance,
        special_allowance: data.data[0].special_allowance,
        transportaion_allowance: data.data[0].transportaion_allowance,
        mobile_tel_allowance: data.data[0].mobile_tel_allowance,
        city_compensatory_allowance: data.data[0].city_compensatory_allowance,
        food_allowance: data.data[0].food_allowance,
        other_allowance: data.data[0].other_allowance,
        bonus: data.data[0].bonus,
        over_time: data.data[0].over_time,
        reimbursement: data.data[0].reimbursement,
        total_earnings: data.data[0].total_earnings,
        total_deductions: data.data[0].total_deductions,
        other_earnings: data.data[0].other_earnings,
        notes: data.data[0].notes,
        net_pay_in_words: data.data[0].net_pay_in_words,
        net_pay: data.data[0].net_pay,
        header1: data.data[0].header1,
        header2: data.data[0].header2,
        header3: data.data[0].header3,
        footer1: data.data[0].footer1,
        footer2: data.data[0].footer2,
        footer3: data.data[0].footer3,
      });
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  }
  const handleFormUpdate = async () => {
    try {
      const { data } = await updatePayslip(params.id, formData, user.token);
      navigate("/payslip-list");
      dispatch(showAlert(data.msg));
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if(name === "employee"){
      getEmpoyeeDataDefault(value)
    }
    setFormData(prevFormData => ({
      ...prevFormData,
      [name]: value || "" 
    }));

    setChange(true);
  };
  
  async function getEmpoyeeDataDefault(empId) {
    if (empId) {
      try {
        const { data } = await getEmpPaySlipDefault(empId, user.token);
  
       
        if (data?.EmpPersonal?.length > 0) {
          const personalData = data.EmpPersonal[0];
          setFormData((prevFormData) => ({
            ...prevFormData,
            employee_code: personalData.employeeid,
            father_name: personalData.father_name,
            bank_name: personalData.bank_name,
            employee: personalData.user_id,
            account_number: personalData.account_number,
            designation: personalData.designation,
            department: personalData.department,
            ifsc_code: personalData.ifsc_code,
            pan_number: personalData.pan,
            payment_mode: personalData.payment_mode,
            joining_date: formatDateToDDMMYYYY(personalData.joining_date),
            uan_number: personalData.uan_number,
            work_location: personalData.job_location,
            effective_days: personalData.effective_days,
          }));
        }
  
        
        if (data?.EmpSalary?.length > 0) {
          const salaryData = data.EmpSalary[0];
          setFormData((prevFormData) => ({
            ...prevFormData,
            health_insurance: salaryData.health_insurance,
            other_deductions: salaryData.other_deductions,
            total_deductions: salaryData.total_deductions,
            basic_pay: salaryData.basic_pay,
            house_rent_allowance: salaryData.house_rent_allowance,
            special_allowance: salaryData.special_allowance,
            transportaion_allowance: salaryData.transportaion_allowance,
            mobile_tel_allowance: salaryData.mobile_tel_allowance,
            city_compensatory_allowance: salaryData.city_compensatory_allowance,
            food_allowance: salaryData.food_allowance,
            other_allowance: salaryData.other_allowance,
            bonus: salaryData.bonus,
            over_time: salaryData.over_time,
            reimbursement: salaryData.reimbursement,
          }));
        } else {
          
          setFormData((prevFormData) => ({
            ...prevFormData,
            health_insurance: "",
            other_deductions: "",
            total_deductions: "",
            basic_pay: "",
            house_rent_allowance: "",
            special_allowance: "",
            transportaion_allowance: "",
            mobile_tel_allowance: "",
            city_compensatory_allowance: "",
            food_allowance: "",
            other_allowance: "",
            bonus: "",
            over_time: "",
            reimbursement: "",
          }));
        }
  
    }catch (error) {
   
      }
    }
    }
  useEffect(() => {
    setFormData(prevFormData => {
      const totalEarning =
        parseFloat(prevFormData.basic_pay || 0.0) +
        parseFloat(prevFormData.house_rent_allowance || 0.0) +
        parseFloat(prevFormData.bonus || 0.0) +
        parseFloat(prevFormData.special_allowance || 0.0) +
        parseFloat(prevFormData.transportaion_allowance || 0.0) +
        parseFloat(prevFormData.mobile_tel_allowance || 0.0) +
        parseFloat(prevFormData.city_compensatory_allowance || 0.0) +
        parseFloat(prevFormData.food_allowance || 0.0) +
        parseFloat(prevFormData.other_allowance || 0.0) +
        parseFloat(prevFormData.over_time || 0.0) +
        parseFloat(prevFormData.reimbursement || 0.0) +
        parseFloat(prevFormData.other_earnings || 0.0);
  
      const totalDeduction =
        parseFloat(prevFormData.tax_deducted_at_source || 0.0) +
        parseFloat(prevFormData.epf || 0.0) +
        parseFloat(prevFormData.health_insurance || 0.0) +
        parseFloat(prevFormData.other_deductions || 0.0);
  
      return {
        ...prevFormData,
        total_earnings: totalEarning,
        total_deductions: totalDeduction,
        net_pay: totalEarning - totalDeduction,
        net_pay_in_words: numberToWords(totalEarning - totalDeduction || 0)
      };
    });
    setChange(false);
  }, [change]);
  

  function numberToWords(number) {
    const ones = [
      "",
      "One",
      "Two",
      "Three",
      "Four",
      "Five",
      "Six",
      "Seven",
      "Eight",
      "Nine",
    ];
    const teens = [
      "",
      "Eleven",
      "Twelve",
      "Thirteen",
      "Fourteen",
      "Fifteen",
      "Sixteen",
      "Seventeen",
      "Eighteen",
      "Nineteen",
    ];
    const tens = [
      "",
      "ten",
      "Twenty",
      "Thirty",
      "Forty",
      "Fifty",
      "Sixty",
      "Seventy",
      "Eighty",
      "Ninety",
    ];
  
    if (number < 0) {
      dispatch(showAlert("Please enter a non-negative number."));
      return ;
    }

    if (number === 0) return "Zero";
  
    let words = "";
    if (number < 0) {
      words += "Minus ";
      number = Math.abs(number);
    }
  
    if (number >= 10000 && number < 11000) {
      words += "Ten Thousand ";
      number %= 1000;
    }
  
    if (number >= 1000000000) {
      words += numberToWords(Math.floor(number / 1000000000)) + " Billion ";
      number %= 1000000000;
    }
    if (number >= 1000000) {
      words += numberToWords(Math.floor(number / 1000000)) + " Million ";
      number %= 1000000;
    }
    if (number >= 1000) {
      words += numberToWords(Math.floor(number / 1000)) + " Thousand ";
      number %= 1000;
    }
    if (number >= 100) {
      words += numberToWords(Math.floor(number / 100)) + " Hundred ";
      number %= 100;
    }
    if (number >= 20) {
      words += tens[Math.floor(number / 10)];
      if (number % 10 !== 0) {
        words += " " + ones[number % 10];
      }
    } else if (number >= 10) {
      words += teens[number - 10];
    } else if (number > 0) {
      words += ones[number];
    }
  
    return words.trim();
  }

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Paper sx={{ p: "1rem" }}>
        <Box sx={{ pb: 1, mb: 1 }}>
          <PaySlipHeader
            formData={formData}
            handleInputChange={handleInputChange}
          />
        </Box>
        <Box sx={{ pb: 1, mb: 1 }}>
          <PayslipEmployeeDetail
            formData={formData}
            handleInputChange={handleInputChange}
          />
        </Box>
        <Box sx={{ pb: 1, mb: 1 }}>
          <PayslipEarnings
            formData={formData}
            handleInputChange={handleInputChange}
          />
        </Box>
        <Box sx={{ pb: 1, mb: 1 }}>
          <PayslipDeductioin
            formData={formData}
            handleInputChange={handleInputChange}
          />
        </Box>
        <Box sx={{ pb: 1, mb: 1 }}>
          <PayslipNetpay
            formData={formData}
            handleInputChange={handleInputChange}
          />
        </Box>
        <Box sx={{ pb: 1, mb: 1 }}>
          <PaySlipFooter
            formData={formData}
            handleInputChange={handleInputChange}
          />
        </Box>
        <Box
          sx={{
            ml: 10,
            m:8,
            display: "flex",
            justifyContent: "space-between",
          }}
        >
 <Button
            onClick={() => {
              navigate("/Payslip-list");
            }}
            sx={{ml:7,borderRadius:"10px",fontWeight:"bold"}}
            variant="contained"
            color="inherit"
          >
            Cancel
          </Button>
          <div>
            <Button           
              sx={{mr: 8,borderRadius:"10px" ,fontWeight:"bold"}}
            variant="contained"
            color="info"
             onClick={handleFormUpdate}>
              Apply Changes
            </Button>

          </div>
        </Box>
      </Paper>
    </Box>
  );
}


function formatDateToYYYYMMDD(isoDateString) {
  if (!isoDateString) return ""; // Return empty string if input is falsy

  const datePortion = isoDateString.split("T")[0];
  return datePortion;
}

function formatDateToDDMMYYYY(dateString) {
  if (!dateString) return ""; // Return empty string if input is falsy
  
  const parts = dateString.split("/");
  if (parts.length !== 3) return ""; // Invalid date format
  
  const day = parts[1];
  const month = parts[0];
  const year = parts[2];

  return `${year}-${month}-${day}`;
}
